<template>
  <div class="content if-profile report-tab">
    <div class="md-layout profit-loss">
      <IFReportHeader :headerData="this.headerData" />

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
        <div class="navbar md-toolbar md-transparent md-elevation-4 p-0 mt-4">
          <h1 class="section_header">Company Financial</h1>
          <div class="md-toolbar-row fundamentals_wpr p-0 if-report-profit-and-loss">
            <nav-tabs-card no-label md-elevation="0">
              <template slot="content">
                <md-tabs @md-changed="onTabChanged" md-alignment="left" class="p-0">
                  <md-tab id="tab-income" md-label="Income Statement" md-icon="grading" class="p-0">
                    <div class="md-toolbar-row fundamentals_area p-0">
                      <nav-tabs-card no-label md-elevation="0">
                        <template slot="content">
                          <md-tabs md-alignment="left" class="p-0">
                            <md-tab
                              v-if="this.display_by_percentages"
                              id="tab-money"
                              md-label="Percentages"
                              md-icon="percent"
                              class="p-0"
                            >
                              <div class="md-layout">
                                <div class="md-layout-item p-0">
                                  <md-card class="m-0">
                                    <md-card-header>Percentages</md-card-header>
                                    <md-card-content>
                                      <div class="md-layout">
                                        <div
                                          class="md-layout-item md-medium-size-100 md-size-100 p-0"
                                        >
                                          <md-table
                                            v-model="tableDataFirmPercent"
                                            table-header-color="blue"
                                            class="profit-and-loss-table"
                                          >
                                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                                              <md-table-cell
                                                :md-label="headerData.client_name?headerData.client_name:'Company'"
                                                :class="item.name === 'Cost of Sales - Labor Portion'
                                                ? 'md-table-side-label pl-2'
                                                : 'md-table-side-label'"
                                              >
                                                {{ item.name }}
                                                <md-tooltip
                                                  md-direction="bottom"
                                                >{{ item.rollover }}</md-tooltip>
                                              </md-table-cell>

                                              <md-table-cell md-label="Trend" class="table_chart">
                                                <chart-card
                                                  header-animation="false"
                                                  :chart-data="newChartFirmPercentOptions[item.name].data"
                                                  :chart-options="chartOptions"
                                                  chart-type="Line"
                                                  header-icon
                                                  chart-inside-content
                                                  no-footer
                                                  background-color="blue"
                                                ></chart-card>
                                              </md-table-cell>

                                              <md-table-cell
                                                v-for="key in Object.keys(
                                                  item.dates
                                                )"
                                                :key="key"
                                                :md-label="key"
                                              >
                                                {{
                                                  item.dates[key]
                                                }}%
                                              </md-table-cell>
                                            </md-table-row>
                                          </md-table>
                                          <md-table
                                            v-model="tableDataIndustryPercent"
                                            table-header-color="blue"
                                            class="profit-and-loss-table mt-4"
                                          >
                                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                                              <md-table-cell
                                                md-label="Industry"
                                                :class="item.name === 'Cost of Sales - Labor Portion'
                                                ? 'md-table-side-label pl-2'
                                                : 'md-table-side-label'"
                                              >
                                                {{ item.name }}
                                                <md-tooltip
                                                  md-direction="bottom"
                                                >{{ item.rollover }}</md-tooltip>
                                              </md-table-cell>

                                              <md-table-cell md-label="Trend" class="table_chart">
                                                <chart-card
                                                  header-animation="false"
                                                  :chart-data="newChartIndustryPercentOptions[item.name].data"
                                                  :chart-options="chartOptions"
                                                  chart-type="Line"
                                                  header-icon
                                                  chart-inside-content
                                                  no-footer
                                                  background-color="blue"
                                                ></chart-card>
                                              </md-table-cell>

                                              <md-table-cell
                                                v-for="key in Object.keys(
                                                  item.dates
                                                )"
                                                :key="key"
                                                :md-label="key"
                                              >
                                                {{
                                                  item.dates[key]
                                                }}%
                                              </md-table-cell>
                                            </md-table-row>
                                          </md-table>
                                        </div>
                                      </div>
                                    </md-card-content>
                                  </md-card>
                                </div>
                              </div>
                            </md-tab>
                            <md-tab
                              v-if="this.display_by_dollars"
                              id="tab-payments"
                              md-label="Dollars"
                              md-icon="payments"
                              class="p-0"
                            >
                              <div class="md-layout">
                                <div class="md-layout-item p-0">
                                  <md-card class="m-0">
                                    <md-card-header>
                                      Dollars
                                      <span>( All figures in USD )</span>
                                    </md-card-header>
                                    <md-card-content>
                                      <div class="md-layout">
                                        <div
                                          class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                        >
                                          <md-table
                                            v-model="tableDataFirmDollar"
                                            table-header-color="blue"
                                            class="profit-and-loss-table"
                                          >
                                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                                              <md-table-cell
                                                :md-label="headerData.client_name"
                                                :class="item.name === 'Cost of Sales - Labor Portion'
                                                ? 'md-table-side-label pl-2'
                                                : 'md-table-side-label'"
                                              >
                                                {{ item.name }}
                                                <md-tooltip
                                                  md-direction="bottom"
                                                >{{ item.rollover }}</md-tooltip>
                                              </md-table-cell>
                                              <md-table-cell md-label="Trend" class="table_chart">
                                                <chart-card
                                                  header-animation="false"
                                                  :chart-data="newChartFirmDollarOptions[item.name].data"
                                                  :chart-options="chartOptions"
                                                  chart-type="Line"
                                                  header-icon
                                                  chart-inside-content
                                                  no-footer
                                                  background-color="blue"
                                                ></chart-card>
                                              </md-table-cell>

                                              <md-table-cell
                                                v-for="key in Object.keys(
                                                  item.dates
                                                )"
                                                :key="key"
                                                :md-label="key"
                                              >
                                                ${{
                                                  item.dates[key]
                                                }}
                                              </md-table-cell>
                                            </md-table-row>
                                          </md-table>
                                          <md-table
                                            v-model="tableDataIndustryDollar"
                                            table-header-color="blue"
                                            class="profit-and-loss-table mt-4"
                                          >
                                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                                              <md-table-cell
                                                md-label="Industry"
                                                :class="item.name === 'Cost of Sales - Labor Portion'
                                                ? 'md-table-side-label pl-2'
                                                : 'md-table-side-label'"
                                              >
                                                {{ item.name }}
                                                <md-tooltip
                                                  md-direction="bottom"
                                                >{{ item.rollover }}</md-tooltip>
                                              </md-table-cell>

                                              <md-table-cell md-label="Trend" class="table_chart">
                                                <chart-card
                                                  header-animation="false"
                                                  :chart-data="newChartIndustryDollarOptions[item.name].data"
                                                  :chart-options="chartOptions"
                                                  chart-type="Line"
                                                  header-icon
                                                  chart-inside-content
                                                  no-footer
                                                  background-color="blue"
                                                ></chart-card>
                                              </md-table-cell>

                                              <md-table-cell
                                                v-for="key in Object.keys(
                                                  item.dates
                                                )"
                                                :key="key"
                                                :md-label="key"
                                              >
                                                ${{
                                                  item.dates[key]
                                                }}
                                              </md-table-cell>
                                            </md-table-row>
                                          </md-table>
                                        </div>
                                      </div>
                                    </md-card-content>
                                  </md-card>
                                </div>
                              </div>
                            </md-tab>
                            <md-tab
                              v-if="this.display_by_variance"
                              id="tab-varience"
                              md-label="Variance"
                              md-icon="dashboard"
                              class="p-0"
                            >
                              <div class="md-layout">
                                <div class="md-layout-item p-0">
                                  <md-card class="m-0">
                                    <md-card-header>Variance</md-card-header>
                                    <md-card-content>
                                      <div class="md-layout">
                                        <div
                                          class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                        >
                                          <md-table
                                            v-model="tableDataVarianceDollar"
                                            table-header-color="blue"
                                            class="profit-and-loss-table"
                                          >
                                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                                              <md-table-cell
                                                :md-label="headerData.client_name"
                                                :class="item.name === 'Cost of Sales - Labor Portion'
                                                ? 'md-table-side-label pl-2'
                                                : 'md-table-side-label'"
                                              >
                                                {{ item.name }}
                                                <md-tooltip
                                                  md-label="Parameters"
                                                  md-direction="bottom"
                                                >{{ item.rollover }}</md-tooltip>
                                              </md-table-cell>

                                              <md-table-cell md-label="Trend" class="table_chart">
                                                <chart-card
                                                  header-animation="false"
                                                  :chart-data="newChartVarianceDollarOptions[item.name].data"
                                                  :chart-options="chartOptions"
                                                  chart-type="Line"
                                                  header-icon
                                                  chart-inside-content
                                                  no-footer
                                                  background-color="blue"
                                                ></chart-card>
                                              </md-table-cell>

                                              <md-table-cell
                                                v-for="key in Object.keys(
                                                  item.dates
                                                )"
                                                :key="key"
                                                :md-label="key"
                                              >
                                                {{
                                                  item.dates[key]
                                                }}
                                              </md-table-cell>
                                            </md-table-row>
                                          </md-table>
                                        </div>
                                      </div>
                                    </md-card-content>
                                  </md-card>
                                </div>
                              </div>
                            </md-tab>
                            <md-tab
                              v-if="this.display_by_variance"
                              id="tab-charts"
                              md-label="Charts"
                              md-icon="pie_chart"
                              class="p-0"
                            >
                              <div class="md-layout">
                                <div class="md-layout-item p-0">
                                  <md-card class="m-0">
                                    <md-card-header>
                                      Charts
                                      <span>( All figures in USD )</span>
                                    </md-card-header>
                                    <md-card-content>
                                      <div class="md-layout px-4 mb-4">
                                        <div
                                          v-for="(chart, i) in charts"
                                          :key="i"
                                          class="md-layout-item md-medium-size-100 md-size-50 mt-4"
                                        >
                                          <chart-card
                                            header-animation="false"
                                            :chart-data="chart.data"
                                            :chart-options="
                                              getOptions(chart.options)
                                            "
                                            chart-type="Pie"
                                            header-icon
                                            chart-inside-content
                                            background-color="blue"
                                          >
                                            <template slot="chartInsideHeader">
                                              <h4 class="title m-0">
                                                <div
                                                  class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                                >{{ chart.title }}</div>
                                              </h4>
                                            </template>
                                            <template slot="footer">
                                              <div class="md-layout">
                                                <div class="md-layout-item md-size-100">
                                                  <p class="common_footer black-color">Copyright © 2022 Bizminer. All Rights Reserved.</p>
                                                </div>
                                                <div class="md-layout-item">
                                                  <span
                                                    v-for="(v, i) in chart
                                                    .options.legendNames"
                                                    :key="i"
                                                    :class="`ct-series-${i}`"
                                                  >
                                                    <i class="fa fa-circle"></i>
                                                    {{ v }} ({{
                                                      chart.options.labelInterpolationSignFn(
                                                        chart.data.series[i]
                                                      )
                                                    }})
                                                  </span>
                                                </div>
                                              </div>
                                            </template>
                                          </chart-card>
                                        </div>
                                      </div>
                                    </md-card-content>
                                  </md-card>
                                </div>
                              </div>
                            </md-tab>
                          </md-tabs>
                        </template>
                      </nav-tabs-card>
                    </div>
                  </md-tab>
                  <md-tab
                    id="tab-balance"
                    md-label="Balance Sheet"
                    md-icon="table_chart"
                    class="p-0"
                  >
                    <div class="md-toolbar-row fundamentals_area p-0">
                      <IFBalanceSheetReport :headerData="headerData" />
                    </div>
                  </md-tab>
                  <md-tab
                    id="tab-source"
                    md-label="Sources &amp; Uses of Funds"
                    md-icon="library_books"
                    class="p-0"
                  >
                    <div class="md-toolbar-row fundamentals_area p-0">
                      <IFSourcesUses />
                    </div>
                  </md-tab>
                </md-tabs>
              </template>
            </nav-tabs-card>
            <IFReportSidebar />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ChartCard, NavTabsCard } from '@/components';
import { mapState } from 'vuex';
import formatData from '@/mixins/format-data';
import IFReportHeader from './_partials/IFHeader.vue';
import IFReportSidebar from './_partials/IFReportSidebar.vue';
import IFBalanceSheetReport from './IFBalanceSheetReport.vue';
import IFSourcesUses from './IFSourcesUses.vue';

export default {
  components: {
    IFReportHeader,
    IFReportSidebar,
    ChartCard,
    NavTabsCard,
    IFBalanceSheetReport,
    IFSourcesUses,
  },
  mixins: [formatData],
  props: ['headerData'],
  data() {
    return {
      view: 'dollar',
      tableDataIndustryDollar: [],
      tableDataIndustryPercent: [],
      tableDataFirmDollar: [],
      tableDataFirmPercent: [],
      tableDataVarianceDollar: [],
      newChartFirmPercentOptions: [],
      newChartIndustryPercentOptions: [],
      newChartIndustryDollarOptions: [],
      newChartFirmDollarOptions: [],
      newChartVarianceDollarOptions: [],
      chartOptions: {
        lineSmooth: this.$Chartist.Interpolation.cardinal({
          tension: 1,
        }),
        chartPadding: {
          top: 5,
          right: 5,
          bottom: 5,
          left: 5
        },
        axisY: {
          showGrid: false,
          showLabel: false,
          offset: 0,
        },
        axisX: {
          showGrid: false,
          showLabel: false,
          offset: 0,
          scaleMinSpace: 6
        },
        showPoint: true,
        showLabel: false,
        width: "100px",
        height: "25px",
        seriesBarDistance: 10,
        fullWidth: true,
      },
      charts: [],
      options: {
        donut: true,
        showLabel: false,
        legendNames: [],
        height: '250px',
      },
      display_by_dollars: true,
      display_by_percentages: true,
      display_by_variance: true,
    };
  },
  computed: {
    ...mapState({
      chartData: (state) => state.user.report.chartData['profitLoss'],
      table: (state) => state.user.report.tables['PL'],
      showYears: (state) => state.user.report.showYears,
      years: (state) => state.user.report.years,
      report: (state) => state.user.report,
      rolloverAux: (state) => state.user.report.data[0].array_BB.array_lookup_ALL,
    }),
  },
  mounted() {
    let section = this.$route.query.section;

    if (!section) {
      section = 'dollar';
    }

    if (
      this.report.displaySettings.includes('pl_balance_percent') &&
      this.report.displaySettings.includes('pl_balance_dollar')
    ) {
      this.display_by_dollars = true;
      this.display_by_percentages = true;
      this.display_by_variance = true;
    }
    if (
      this.report.displaySettings.includes('pl_balance_dollar') &&
      !this.report.displaySettings.includes('pl_balance_percent')
    ) {
      this.display_by_dollars = true;
      this.display_by_variance = true;
    }
    if (
      this.report.displaySettings.includes('pl_balance_percent') &&
      !this.report.displaySettings.includes('pl_balance_dollar')
    ) {
      this.display_by_percentages = true;
      this.display_by_variance = true;
    }
    if (
      !this.report.displaySettings.includes('pl_balance_percent') &&
      !this.report.displaySettings.includes('pl_balance_dollar')
    ) {
      this.display_by_dollars = false;
      this.display_by_percentages = false;
      this.display_by_variance = false;
    }

    if (!this.report.displaySettings.includes('pl_balance_percent'))
      this.display_by_percentages = false;

    if (!this.report.displaySettings.includes('pl_balance_dollar'))
      this.display_by_dollars = false;


    this.switchView(section);
    let filtered_years = [];
    this.showYears.forEach((s, i) => {
      if (s) {
        filtered_years.push(this.years[i]);
      }
    });
    if (!filtered_years.length) {
      filtered_years = this.years;
    }

    var rolloverArray = [];
    Object.entries(this.rolloverAux).forEach(([index, item]) => {
      rolloverArray[item.title] = item.description;
    });
    this.tableDataVarianceDollar = this.formatTable(
      this.table,
      'variance',
      'dollar',
      rolloverArray
    );
    this.tableDataVarianceDollar = this.tableDataVarianceDollar.map((item) => {
      let changeDates = Object.keys(item.dates);
      changeDates = changeDates.filter((fItem) => {
        return !filtered_years.includes(fItem);
      });
      let newDates = item.dates;
      changeDates.map((el) => {
        delete newDates[el];
      });
      let obj = {
        ...item,
        dates: newDates,
      };

      return obj;
    });

    this.tableDataVarianceDollar.forEach(element => {
      this.newChartVarianceDollarOptions[element.name] = {
        data: {
          labels: [[...Object.keys(element.dates).map(i => element.dates[i].toString().replace(/,/g, "").replace('%', ''))]],
          series: [[...Object.keys(element.dates).map(i => element.dates[i].toString().replace(/,/g, "").replace('%', ''))]]
        },
      }
    });

    this.tableDataIndustryDollar = this.formatTable(
      this.table,
      'industry',
      'dollar',
      rolloverArray
    );
    this.tableDataIndustryDollar = this.tableDataIndustryDollar.map((item) => {
      let changeDates = Object.keys(item.dates);
      changeDates = changeDates.filter((fItem) => {
        return !filtered_years.includes(fItem);
      });
      let newDates = item.dates;
      changeDates.map((el) => {
        delete newDates[el];
      });
      let obj = {
        ...item,
        dates: newDates,
      };

      return obj;
    });

    this.tableDataIndustryDollar.forEach(element => {
      this.newChartIndustryDollarOptions[element.name] = {
        data: {
          labels: [[...Object.keys(element.dates).map(i => element.dates[i].toString().replace(/,/g, "").replace('%', ''))]],
          series: [[...Object.keys(element.dates).map(i => element.dates[i].toString().replace(/,/g, "").replace('%', ''))]]
        },
      }
    });


    this.tableDataIndustryPercent = this.formatTable(
      this.table,
      'industry',
      'percent',
      rolloverArray
    );
    this.tableDataIndustryPercent = this.tableDataIndustryPercent.map(
      (item) => {
        let changeDates = Object.keys(item.dates);
        changeDates = changeDates.filter((fItem) => {
          return !filtered_years.includes(fItem);
        });
        let newDates = item.dates;
        changeDates.map((el) => {
          delete newDates[el];
        });
        let obj = {
          ...item,
          dates: newDates,
        };

        return obj;
      }
    );

    this.tableDataIndustryPercent.forEach(element => {
      this.newChartIndustryPercentOptions[element.name] = {
        data: {
          labels: [[...Object.keys(element.dates).map(i => element.dates[i].toString().replace(/,/g, "").replace('%', ''))]],
          series: [[...Object.keys(element.dates).map(i => element.dates[i].toString().replace(/,/g, "").replace('%', ''))]]
        },
      }
    });

    this.tableDataFirmDollar = this.formatTable(this.table, 'firm', 'dollar', rolloverArray);
    this.tableDataFirmDollar = this.tableDataFirmDollar.map((item) => {
      let changeDates = Object.keys(item.dates);
      changeDates = changeDates.filter((fItem) => {
        return !filtered_years.includes(fItem);
      });
      let newDates = item.dates;
      changeDates.map((el) => {
        delete newDates[el];
      });
      let obj = {
        ...item,
        dates: newDates,
      };

      return obj;
    });
    this.tableDataFirmDollar.forEach(element => {
      this.newChartFirmDollarOptions[element.name] = {
        data: {
          labels: [[...Object.keys(element.dates).map(i => element.dates[i].toString().replace(/,/g, "").replace('%', ''))]],
          series: [[...Object.keys(element.dates).map(i => element.dates[i].toString().replace(/,/g, "").replace('%', ''))]]
        },
      }
    });
    this.tableDataFirmPercent = this.formatTable(this.table, 'firm', 'percent', rolloverArray);
    this.tableDataFirmPercent = this.tableDataFirmPercent.map((item) => {
      let changeDates = Object.keys(item.dates);
      changeDates = changeDates.filter((fItem) => {
        return !filtered_years.includes(fItem);
      });
      let newDates = item.dates;
      changeDates.map((el) => {
        delete newDates[el];
      });
      let obj = {
        ...item,
        dates: newDates,
      };

      return obj;
    });

    this.tableDataFirmPercent.forEach(element => {
      this.newChartFirmPercentOptions[element.name] = {
        data: {
          labels: [[...Object.keys(element.dates).map(i => element.dates[i].toString().replace(/,/g, "").replace('%', ''))]],
          series: [[...Object.keys(element.dates).map(i => element.dates[i].toString().replace(/,/g, "").replace('%', ''))]]
        },
      }
    });
    if (this.chartData) {
      //delete this.chartData.percentage;
      this.charts = this.formatPieChart(this.chartData);
    }
  },
  watch: {
    '$route.query.section'() {
      let section = this.$route.query.section;

      if (!section) {
        section = 'dollar';
      }

      this.switchView(section);
    },
  },
  methods: {
    switchView: function (type) {
      this.view = type;
    },
    getOptions(newOptions) {
      return {
        ...this.options,
        ...newOptions,
      };
    },
    onTabChanged(index) {
      if (index === 'tab-income') {
        this.$store.commit(
          'user/SET_ACTIVE_SECTION',
          'IF Industry Financials Income Statement'
        );
      }
      if (index === 'tab-balance') {
        this.$store.commit(
          'user/SET_ACTIVE_SECTION',
          'IF Industry Financials Balance Sheet'
        );
      }
      if (index === 'tab-source') {
        this.$store.commit(
          'user/SET_ACTIVE_SECTION',
          'IF Industry Financials Sources & Uses Of Funds'
        );
      }
    },
  },
};
</script>
<style lang="scss">
.profit-loss {
  .financal-report-col-1 {
    display: flex;
    align-items: center;

    h4 {
      margin-top: 0;
    }
  }

  .financal-report-col-2 {
    .access-button {
      margin-top: 18px !important;
    }

    .financal-report-col-3 {
      display: flex;
      justify-content: flex-end;
    }
  }

  .heder-titel-col-2 {
    margin-bottom: 35px;
  }

  .summary-scores-box-star {
    .md-button-content {
      .md-icon {
        color: #3b7ef1;
      }
    }

    h4 {
      margin-left: 60px;
    }
  }

  .summary-scores-box-flag {
    .md-icon {
      color: #3b7ef1;
    }

    .w-100 {
      width: 100%;
    }
  }

  .md-collapse-content {
    padding: 0 !important;
  }

  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }
}
</style>
